import api from "../js/axios";

export const WebService = {
    getBlog: async () => {
        const response = await api.get('/web/getBlog');
        return response.data;
    },
    getBlogByID: async (blog_id) => {
        const response = await api.get(`/web/getBlogByID/${blog_id}`);
        return response.data;
    },
    getBlogHome: async () => {
        const response = await api.get('/web/getBlogHome');
        return response.data;
    },
    getCuestionario: async (id) => {
        const response = await api.get(`/web/getCuestionario/${id}`);
        return response.data;
    },
    getCursos: async (nominaID) => {
        const response = await api.get(`/web/getCursos/${nominaID}`);
        return response.data;
    },
    getEmpleadosCredenciales: async (contratoID) => {
        const response = await api.get(`/web/getEmpleadosCredencialesByContratoID/${contratoID}`);
        return response.data;
    },
    getContratosActivos: async () => {
        const response = await api.get('/web/getContratosActivos');
        return response.data;
    },
    generarCertificado : async (tipo, contratoID, data) => {
        const endpoints = {
            credenciales: `/web/generarCredencialesWebPDF/${contratoID}`,
            credencial: `/web/generarCredencialWebPDF/${contratoID}`,
        };

        // Esto lanza un error si el tipo no existe
        if (!endpoints[tipo]) throw new Error("Tipo de certificado no definido");

        // Enviamos los datos. El interceptor de axios maneja el error global
        const { data: response } = await api.post(endpoints[tipo], data);
        return response;
    },
};